import React from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '../../../Modal';
import {Button} from '../../../Button';
import {ButtonContinue, ButtonWrapper, Subtitle} from './styled';

export type WarningCloseModalProps = {
  visible: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const WarningCloseModal = ({visible, onClose, onContinue}: WarningCloseModalProps) => {
  const {t} = useTranslation();

  return (
    <Modal zIndex={1200} closeOnDocumentClick open={visible} onClose={onContinue}>
      <h1>{t('discard_changes_question')}</h1>
      <Subtitle>{t('discard_changes_question_subtitle')}</Subtitle>
      <ButtonWrapper>
        <ButtonContinue onClick={onClose} label={t('discard')} />
        <Button onClick={onContinue} label={t('cancel')} secondary />
      </ButtonWrapper>
    </Modal>
  );
};

export {WarningCloseModal};
